import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Sends the textarea HTML to POST /admin/preview and shows the sanitized result in #html-preview-modal.
// With a deck id the server renders it as the face of that deck's game card.
export default class extends Controller {
  static targets = ["source"]
  static values = { url: String, deckId: String }

  async show(event) {
    event.preventDefault()
    const modalElement = document.getElementById("html-preview-modal")
    const body = modalElement.querySelector("[data-preview-body]")
    body.innerHTML = '<div class="text-center py-4"><div class="spinner-border text-primary" role="status"></div></div>'
    Modal.getOrCreateInstance(modalElement).show()

    const form = new FormData()
    form.append("html", this.sourceTarget.value)
    if (this.deckIdValue) form.append("deck_id", this.deckIdValue)
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, { method: "POST", body: form, headers: { "X-CSRF-Token": token, "Accept": "text/html" } })
      if (response.redirected) {
        // Expired admin session: Devise redirected to the login page.
        body.innerHTML = '<div class="alert alert-danger mb-0">Сессия истекла — войдите снова</div>'
      } else {
        body.innerHTML = response.ok ? await response.text() : '<div class="alert alert-danger mb-0">Не удалось построить предпросмотр</div>'
      }
    } catch (_) {
      body.innerHTML = '<div class="alert alert-danger mb-0">Нет связи с сервером</div>'
    }
  }
}
